import { render } from "./chat-list.vue?vue&type=template&id=58e31e61"
import script from "./chat-list.vue?vue&type=script&lang=js"
export * from "./chat-list.vue?vue&type=script&lang=js"

import "./chat-list.vue?vue&type=style&index=0&id=58e31e61&lang=scss"

import exportComponent from "/Users/apple/Documents/jmd/Templates/Templates/chatgpt-tpl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__